module.exports = __webpack_public_path__ + "static/media/twitch.7e51704e.svg";